export const useViewedAudiencesStore = defineStore('viewed-audiences', () => {
  const viewedAudiences = ref<Record<string, number>>({})

  function viewAudiences(newAudiences: string[]) {
    const updatedAudiences = { ...viewedAudiences.value }

    if (newAudiences?.length) {
      newAudiences.forEach((audience) => {
        updatedAudiences[audience] = updatedAudiences[audience]
          ? (updatedAudiences[audience] += 1)
          : 1
      })
    }

    viewedAudiences.value = updatedAudiences
  }

  return {
    viewAudiences,
    viewedAudiences,
  }
})
